import { create } from 'zustand';
import { ApiUtils, ApplicationApi, RequestStrategyEnum } from '@shared/api';

interface IRejectApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  rejectApplication: (applicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRejectApplication2Store = create<IRejectApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  rejectApplication: ApiUtils.wrapperApi(async (applicationId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.rejectApplication(applicationId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
